import React from "react";
import locale from "@bonliva-crm/locale";
import { Paper } from "@material-ui/core";
import { Body } from "@components";

interface StaffingPortalBlockedErrorProps {
  /** The staffing portal the picked customer's organisation is on, e.g. "Bemlo" or "Medlo". */
  portal: string;
}

/**
 * Shown under the customer picker the moment a customer on a blocked staffing portal is
 * selected, before the rest of the form is filled in (CRMDEV-7351, ERP-1489). Submit is
 * disabled for as long as it is visible.
 */
export function StaffingPortalBlockedError({ portal }: StaffingPortalBlockedErrorProps) {
  return (
    <Paper
      style={{
        padding: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Body color="error">{locale.staffingPortalCustomerBookingBlocked(portal)}</Body>
    </Paper>
  );
}
